export default __webpack_public_path__ + "177d5d3eb84658a21317cc5ff1ce1211.svg";